import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CnafContacterMaCafService } from '../../../services/contactermacaf.service';
import { CnafUserService, CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { Router } from '@angular/router';
import { TagXitiService } from '../../../services/tagxiti.service';
import { context } from '../../../../../src/contexts/context';
import { ContactermacafMotifsdecontactComponent } from '../../contactermacaf-motifsdecontact.component';
@Component({
  selector: 'app-contactermacaf-motifsdecontact-dettes',
  templateUrl: 'motifsdecontact-dettes.component.html',
  styleUrls: ['../../contactermacaf-motifsdecontact.component.css']
})
export class MotifsdecontactDettesComponent extends ContactermacafMotifsdecontactComponent implements OnInit {

  constructor(
    private _router: Router,
    private _cnafContacterMaCafService: CnafContacterMaCafService,
    private _cnafAtTagService: CnafAtTagService,
    private _tagXitiService: TagXitiService,
    private cnafUserService: CnafUserService
  ) {
    super(_router,_cnafContacterMaCafService);
  }
  hasDettes: boolean = true;

  ngOnInit(): void {
    this.chapitre3 = 'dettes';
    this.hasDettes = this.cnafUserService.isInGroup(
      this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_REMBOURSEMENTS);
    super.ngOnInit();
  } 

  onPayerEnLigne() {
    const tagObj = this._tagXitiService.getAtTagObject(
      'btn_payer_en_ligne ',
      context.type,
      'contactermacaf',
      'svi_visuel_choix_motif',
      "dettes"
    );
    tagObj.customPropsPersistent = {
      'svi_profil': this._tagXitiService.getProfilutilisateur()
    };
    this._cnafAtTagService.pageSend(tagObj);

    setTimeout(() => {
      window.location.href = '/redirect/s/Redirect?page=applimobileMonCompteMesRemboursements';
    }, 300);
  }

  onEnvoyerEmail() {
    const tagObj = this._tagXitiService.getAtTagObject(
      'btn_envoyer_mail',
      context.type,
      'contactermacaf',
      'svi_visuel_choix_motif',
      "dettes"
    );
    tagObj.customPropsPersistent = {
      'svi_profil': this._tagXitiService.getProfilutilisateur()
    };
    this._cnafAtTagService.pageSend(tagObj);
    setTimeout(() => {
      window.location.href = '/redirect/s/Redirect?page=monCompteContactCafCourriel';
    }, 300);

  }

  onPrendreRdv() {
    const tagObj = this._tagXitiService.getAtTagObject(
      'btn_prendre_rdv',
      context.type,
      'contactermacaf',
      'svi_visuel_choix_motif',
      "dettes"
    );
    tagObj.customPropsPersistent = {
      'svi_profil': this._tagXitiService.getProfilutilisateur()
    };
    this._cnafAtTagService.pageSend(tagObj);
    setTimeout(() => {
      window.location.href = '/redirect/s/Redirect?page=monComptePrendreUnRendezVous';
    }, 300);

  }
}
